import React, { useState, useEffect } from 'react';
import { Col, Row, Image, Alert, Dropdown, DropdownButton } from 'react-bootstrap';
import styles from './offerHandling.module.scss';
import { CustomSearch } from '../../shared/customSearch';
import { CustomButton } from '../../shared/customButton';
import { getOffersByType, markAsOfferSent, markAsCandidateDeclinedOffer, markAsOfferRetracted, markAsCandidateAcceptedOffer } from '../../../services/util/offerHandling';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../customNavbar';
import { useParams, useHistory } from 'react-router-dom';
// import {CreatePipelineModal} from './createPipelineModal';
import makeAnimated from 'react-select/animated';
import Select from 'react-select'
import SubmitOfferModal from '../offerHandling/submitOfferModal';
import { CustomConfirmationBox } from '../../shared/customConfirmationBox';
import { CustomConfirmationModal } from '../../shared/customConfirmationModal';
import ViewOffer from './viewOfferModal';
import SendOfferToCandidateModal from './sendOfferToCandidateModal';
import SendASingleEmailsToCandidates from '../common/sendASingleEmail/index';
import ReactTooltip from 'react-tooltip';
import { CustomIconButton } from '../../shared/customIconButton';
import { CustomStatusLabel } from '../../shared/customStatusLabel';
import  CSSLoader  from '../../shared/cssLoader';
import Avatar from 'react-avatar';


const OfferHandling = (props) => {
    const animatedComponents = makeAnimated();

    const history = useHistory();
    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let seleted_state = (params.get('state') ? params.get('state') : 100);

    //set an state for default seleted pipeline type
    let [defaultSelectedOfferType, setDefaultSelectedOfferType] = useState({
        label: "All",
        value: 100
    })

    let [isURLLoading, setURLLoading] = useState(false);
    let [noSearchData, setNoSearchData] = useState(false)

    let viewPermission = props.permissions.actions.view_offers;;
    let editPermission = props.permissions.actions.edit_offers;;
    let userRole = props.role;



    //dropdown values of pipeline types
    const offerTypes = [
        {
            label: "All",
            value: 100
        },
        {
            label: "Pending Approval",
            value: 0
        },
        {
            label: "Approved",
            value: 10
        },
        {
            label: "Offer Sent",
            value: 20
        },
        {
            label: "Approval Rejected",
            value: -10
        },
        {
            label: "Candidate Declined",
            value: -20
        }
    ];

    //on change pipeline type
    const changeOfferType = async (type) => {
        setIsDataLoading(true);
        setDefaultSelectedOfferType(type);
        setIsDataLoading(true);
        let respond = await getOffersByType(type.value);
        if (respond.success === true) {
            setArrayValues(respond.data)
            setFilteredValues(respond.data)
            setIsDataLoading(false)
        } else {
            setIsDataLoading(false)
        }
    };

    const refreshData = async () => {
        setIsDataLoading(true);
        let respond = await getOffersByType(defaultSelectedOfferType.value);
        if (respond.success === true) {
            setArrayValues(respond.data)
            setFilteredValues(respond.data)
            setIsDataLoading(false)
        } else {
            setIsDataLoading(false)
        }
    };


    const breadcrumb = [{
        pathaddress: 'app/company/offer-handling',
        pathname: 'Offer Handling',
        isActive: true,
        key: 1 + 'Offer Handling'
    }

        ,
    {
        pathaddress: ``,
        pathname: 'Processing Offers',
        isActive: true,
        key: 1 + 'Processing Offers'

    }]

    // States
    let [isDataLoading, setIsDataLoading] = useState(false);
    const [showEditOfferModal, setShowEditOfferModal] = useState(false);
    const [showViewOfferModal, setShowVieOfferwModal] = useState(false);
    const [showSendOfferToCandidateModal, setShowSendOfferToCandidateModal] = useState(false);
    const [showMarkAsOfferSentModal, setShowMarkAsOfferSentModal] = useState(false);
    const [showMarkASCandidateDeclinedModal, setShowMarkASCandidateDeclinedModal] = useState(false);
    const [showMarkAsOfferRetractedtModal, setShowMarkAsOfferRetractedtModal] = useState(false);
    const [showCandidateAcceptedOfferModal, setShowCandidateAcceptedOfferModal] = useState(false);

    let [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);
    let [selectedCandidateName, setSelectedCandidateName] = useState('');

    let [selectedOfferSessionID, setselectedOfferSessionID] = useState('');

    let [value, setArrayValues] = useState([]);
    let [filteredValues, setFilteredValues] = useState([]);


    let [editRowValues, setEditRowValues] = useState();
    let [viewOfferValues, setViewOfferValues] = useState();

    let [showOfferEmailModal, setShowOfferEmailModal] = useState(false);
    let [emailTemplateName, setEmailTemplateName] = useState('');
    let [candidateEmail, setCandidateEmail] = useState('');

    // functions
    const handleClose = () => {
        setShowEditOfferModal(false);
        setShowVieOfferwModal(false);
        setShowSendOfferToCandidateModal(false)
        setShowMarkAsOfferSentModal(false);
        setShowMarkASCandidateDeclinedModal(false);
        setShowMarkAsOfferRetractedtModal(false);
        setShowCandidateAcceptedOfferModal(false);
        setShowOfferEmailModal(false);
    }

    const editOffer = async (values) => {

        let edit_data = {
            candidateId: values.candidate_id,
            offerSessionId: values._offer_session_id,
            jobTitle: values.offer_data.non_sensitive_data.job_title,
            allocation: values.offer_data.non_sensitive_data.allocation,
            offerDescription: values.offer_data.non_sensitive_data.description,
            packageReference: values.offer_data.non_sensitive_data.package_reference,
            offerReviewers: values.offer_data.assigned_reviewers
        }
        await setEditRowValues(edit_data)
        setShowEditOfferModal(true);
    }

    const viewOffer = async (values) => {
        let offer_data = {
            candidateId: values.candidate_id,
            offerSessionId: values._offer_session_id,
            jobTitle: values.offer_data.non_sensitive_data.job_title,
            allocation: values.offer_data.non_sensitive_data.allocation,
            offerDescription: values.offer_data.non_sensitive_data.description,
            packageReference: values.offer_data.non_sensitive_data.package_reference,
            offerReviewers: values.offer_data.assigned_reviewers,
            pipelineName: values.pipeline_name,
            candidateName: values.candidate_name,
            candidateEmail: values.candidate_email,
            candidatePhoneCode: values.candidate_mobile_country_code,
            candidatePhoneNumber: values.candidate_mobile_number,
            state: values.state,
            stateValue: values.state_value,
            candidateRejectReason: values.candidate_reject_reason,
            offer_sent_date: values.offer_sending_details ? values.offer_sending_details.offer_sent_date : null,
            offer_sent_mode: values.offer_sending_details ? values.offer_sending_details.offer_sent_mode : null,
            candidate_respose_received_mode: values.candidate_respose_received_mode ? values.candidate_respose_received_mode : null,
            candidate_respose_date: values.candidate_respose_date
        }
        await setViewOfferValues(offer_data)
        setShowVieOfferwModal(true);
    }

    const onClickMarkAsOfferSent = async (values) => {
        setSelectedCandidateName(values.candidate_name);
        setselectedOfferSessionID(values._offer_session_id);
        setShowMarkAsOfferSentModal(true);
    }

    const onClickSendOffer = async (values) => {
        let offer_data = {
            candidateId: values.candidate_id,
            offerSessionId: values._offer_session_id,
            jobTitle: values.offer_data.non_sensitive_data.job_title,
            allocation: values.offer_data.non_sensitive_data.allocation,
            offerDescription: values.offer_data.non_sensitive_data.description,
            packageReference: values.offer_data.non_sensitive_data.package_reference,
            offerReviewers: values.offer_data.assigned_reviewers,
            pipelineName: values.pipeline_name,
            candidateName: values.candidate_name,
            candidateEmail: values.candidate_email,
            candidatePhoneCode: values.candidate_mobile_country_code,
            candidatePhoneNumber: values.candidate_mobile_number,
            state: values.state,
            stateValue: values.state_value
        }
        await setViewOfferValues(offer_data)
        setShowSendOfferToCandidateModal(true);
    }

    const onClickCandidateDeclined = async (values) => {
        setSelectedCandidateName(values.candidate_name);
        setselectedOfferSessionID(values._offer_session_id);
        setShowMarkASCandidateDeclinedModal(true);
    }

    const onClickOfferRetracted = async (values) => {
        setSelectedCandidateName(values.candidate_name);
        setselectedOfferSessionID(values._offer_session_id);
        setShowMarkAsOfferRetractedtModal(true);
    }

    const onClickCandidateAcceptedOffer = async (values) => {
        setSelectedCandidateName(values.candidate_name);
        setselectedOfferSessionID(values._offer_session_id);
        setShowCandidateAcceptedOfferModal(true);
    }

    const submitMarkAsOfferSent = async () => {
        setModalActionButtonLoading(true)
        let respond = await markAsOfferSent(selectedOfferSessionID);
        if (respond.success === true) {
            getAllOffers()
            setModalActionButtonLoading(false)
            setShowMarkAsOfferSentModal(false)
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const submitMarkAsCandidateDeclined = async (data) => {
        setModalActionButtonLoading(true)
        let respond = await markAsCandidateDeclinedOffer(selectedOfferSessionID, data.reason);
        if (respond.success === true) {
            getAllOffers()
            setModalActionButtonLoading(false)
            setShowMarkASCandidateDeclinedModal(false)
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const submitMarkAsOfferRetracted = async (data) => {
        setModalActionButtonLoading(true)
        let respond = await markAsOfferRetracted(selectedOfferSessionID, data.reason);
        if (respond.success === true) {
            getAllOffers()
            setModalActionButtonLoading(false)
            setShowMarkAsOfferRetractedtModal(false)
            props.GetTaskValues()
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const submitMarkAsCandidateAcceptedOffer = async () => {
        setModalActionButtonLoading(true)
        let respond = await markAsCandidateAcceptedOffer(selectedOfferSessionID);
        if (respond.success === true) {
            getAllOffers()
            setModalActionButtonLoading(false)
            setShowCandidateAcceptedOfferModal(false)
            props.GetTaskValues()
        } else {
            setModalActionButtonLoading(false)
        }
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = value.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
    }

    const getAllOffers = async () => {
        setIsDataLoading(true)
        let respond = await getOffersByType(seleted_state);
        if (respond.success === true) {
            //setting state label for selected state
            if (seleted_state != 100) {
                for (let index = 0; index < offerTypes.length; index++) {
                    if (offerTypes[index].value == seleted_state) {
                        setDefaultSelectedOfferType(offerTypes[index]);

                    }
                }
            }
            setArrayValues(respond.data)
            setFilteredValues(respond.data)
            setIsDataLoading(false)
        } else {
            setIsDataLoading(false)
        }
    }

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    // function editOffer(val) {
    //     let path = `/app/company/candidate`;
    //     let search = 'cid=' + val;

    //     const url = `${path}?${search}`;
    //     window.open(url);
    // }

    const changeSelectedStateURL = async (state) => {
        history.push({
            pathname: `/app/company/offer-handling`,
            search: `?state=${state}`
        });
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            getAllOffers();
        }
        return () => { unmounted = true };
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [])

    // View
    return (
        <div>
            <Helmet>
                <title>Offer Handling | HireTrace</title>
            </Helmet>


            {/* Modal View End */}

            {
                showEditOfferModal === true ?
                    (<SubmitOfferModal handleClose={handleClose} showModal={showEditOfferModal} editRowValues={editRowValues} isEditMode={true} candidateId={editRowValues.candidateId} refreshData={refreshData} GetTaskValues={props.GetTaskValues} />)
                    : null
            }

            {
                showViewOfferModal === true ?
                    (<ViewOffer handleClose={handleClose} showModal={showViewOfferModal} viewOfferValues={viewOfferValues} />)
                    : null
            }

            {
                showSendOfferToCandidateModal === true ?
                    (<SendOfferToCandidateModal handleClose={handleClose} showModal={showSendOfferToCandidateModal} viewOfferValues={viewOfferValues} refreshData={refreshData} />)
                    : null
            }

            {showOfferEmailModal &&
                <SendASingleEmailsToCandidates showModal={showOfferEmailModal} handleClose={handleClose} offerSessionID={selectedOfferSessionID} refreshData={refreshData} candidateEmail={candidateEmail} emailTemplateName={emailTemplateName} />
            }
            <CustomConfirmationModal
                show={showMarkAsOfferSentModal}
                confirmationType='success'
                cancelIconclick={handleClose}
                onSecondaryBtnClick={handleClose}
                onPrimaryBtnClick={submitMarkAsOfferSent}
                isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage={`You are trying to mark as offer sent for the candidate ${selectedCandidateName}.`}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, Mark As Sent!"
            />

            <CustomConfirmationBox
                show={showMarkASCandidateDeclinedModal}
                cancelIconclick={handleClose}
                onSecondaryBtnClick={handleClose}
                onFormSubmit={submitMarkAsCandidateDeclined}
                preCheckedCondition={true}
                isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message={`You are trying to mark as offer declined by ${selectedCandidateName}.`}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Declined Offer"
            />

            <CustomConfirmationBox
                show={showMarkAsOfferRetractedtModal}
                cancelIconclick={handleClose}
                onSecondaryBtnClick={handleClose}
                onFormSubmit={submitMarkAsOfferRetracted}
                preCheckedCondition={true}
                isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message={`You are trying to mark as offer retracted from ${selectedCandidateName}.`}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Retracted Offer"
            />

            <CustomConfirmationModal
                show={showCandidateAcceptedOfferModal}
                confirmationType='success'
                cancelIconclick={handleClose}
                onSecondaryBtnClick={handleClose}
                onPrimaryBtnClick={submitMarkAsCandidateAcceptedOffer}
                isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage={`You are trying to mark candidate ${selectedCandidateName} as accepted the offer (Hired)`}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, Mark As Hired!"
            />
            {isDataLoading ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <div>
                                <Row>
                                    <Col sm={3} className="mb-2">
                                        <Select
                                            options={offerTypes}
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={defaultSelectedOfferType}
                                            onChange={(e) => {
                                                changeOfferType(e);
                                                changeSelectedStateURL(e.value)
                                            }}
                                            styles={
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #bdbdbd', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                        height: '48px',
                                                        fontFamily: 'var(--app-primary-font-style)',
                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                        fontSize: 'var(--app-primary-font-size)',
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                            }
                                        />
                                    </Col>
                                    <Col sm={9} className="mb-2">
                                        <CustomSearch
                                            placeholder="Search by name"
                                            handleOnChange={(e) => searchValus(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        <div className={styles.tableBodyContainer}>
                            {
                                ((filteredValues.length === 0) && (isDataLoading === false)) ?
                                    (<div>
                                        {noSearchData ?
                                            <Col>
                                                <p className={styles.infoMessage}>No records found for your search, Try a different keyword. </p>
                                            </Col>
                                            :
                                            <div>
                                                <Col>
                                                    <p className={styles.infoMessage}>Currently no pending job offers to handle. Learn more
                                                        about  <a href='https://hiretrace.io/documentation/job-offers/overview' target="_blank">Offer Handling</a>. </p>
                                                </Col>
                                                <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/noOffers.svg`} fluid />
                                                </Col>
                                            </div>
                                        }

                                    </div>)
                                    :
                                    (
                                        <>
                                            <div className={styles.tableContainer}>
                                                <div className={styles.tableFirstRowMainHeaderDiv}>
                                                    <Col sm={3} className={styles.tablePipelineDetailsMainHeaderRow}>
                                                        <p>Candidate Details</p>
                                                    </Col>
                                                    <Col sm={2} className={styles.tableStstusDetailsMainHeaderRow}>
                                                        <p>Phone Number</p>
                                                    </Col>
                                                    <Col sm={3}>
                                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                                            <p>Position/Pipeline</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <Row className={styles.tableCandidatesInfoDetailsHeaderRow}>
                                                            <p>Status</p>

                                                        </Row>
                                                    </Col>
                                                    <Col sm={1}>
                                                        <Row className={styles.tableCandidatesInfoDetailsHeaderRow}>
                                                            <p>Actions</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={1}>

                                                    </Col>
                                                </div>
                                                {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((offer, i) => {
                                                    return (
                                                        <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                            <Col sm={3}>
                                                                <Row className={styles.tableJobDetailsMainRow}>
                                                                    <Col sm={2}>
                                                                        <Avatar name={offer.candidate_name} size="32" round={true} />
                                                                    </Col>
                                                                    <Col sm={10}>
                                                                        <Row className={styles.tableJobDetailsRow}>
                                                                            <p className={styles.tableJobDetails}>{offer?.candidate_name}</p>
                                                                        </Row>
                                                                        <Row className={styles.tableJobDetailsRow}>
                                                                            <p className={styles.tableSecondJobDetails}>{offer?.candidate_email}</p>
                                                                        </Row>
                                                                    </Col>

                                                                </Row>

                                                            </Col>
                                                            <Col sm={2}>
                                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                                    <p className={styles.tableCandidatesInfoDetails}>({offer?.candidate_mobile_country_code}) {offer?.candidate_mobile_number}</p>
                                                                </Row>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <div className={styles.tableJobPositionMainRow}>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableJobDetails}>{offer?.hiring_position}</p>
                                                                    </Row>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableSecondJobDetails}>{offer?.pipeline_name}</p>
                                                                    </Row>
                                                                </div>

                                                            </Col>
                                                            <Col sm={2} className='d-flex align-items-center justify-content-center'>
                                                                <CustomStatusLabel type={(offer.state === 10 || offer.state === 30) ? 'successStatus' : (offer.state === 0 || offer.state === 20) ? 'warningStatus' : (offer.state === -10 || offer.state === -20 || offer.state === -30) ? 'dangerStatus' : 'null'} label={offer.state === 10 ? 'Approved' : offer.state === 20 ? 'Offer Sent' : offer.state === 0 ? 'Pending Approval' : offer.state === 30 ? 'Marked as Offer Sent' : offer.state === -10 ? 'Approval Rejected' : offer.state === -20 ? 'Offer Declined' : offer.state === -30 ? 'Expired' : null}></CustomStatusLabel>
                                                            </Col>
                                                            <Col sm={1}>
                                                                <Row className={styles.tableShareLinksRow}>
                                                                    <>
                                                                        <div className={styles.tableDatActionsLeftBtns}>
                                                                            <CustomIconButton
                                                                                type="successBtn"
                                                                                toolTipId={"viewCandidate"}
                                                                                showToolTip={true}
                                                                                toolTip={'view candidate'}
                                                                                icon={
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 20 21" fill="none">
                                                                                        <path d="M13.3333 15.5L15.8333 13M15.8333 13L18.3333 15.5M15.8333 13V18M9.99996 13.4167H6.24996C5.08699 13.4167 4.5055 13.4167 4.03234 13.5602C2.96701 13.8834 2.13333 14.717 1.81016 15.7824C1.66663 16.2555 1.66663 16.837 1.66663 18M12.0833 6.75C12.0833 8.82107 10.4044 10.5 8.33329 10.5C6.26222 10.5 4.58329 8.82107 4.58329 6.75C4.58329 4.67893 6.26222 3 8.33329 3C10.4044 3 12.0833 4.67893 12.0833 6.75Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                }
                                                                                handleClick={() => viewCandidate(offer.candidate_id)}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <CustomIconButton
                                                                                type="successBtn"
                                                                                toolTipId={"viewOffer"}
                                                                                showToolTip={true}
                                                                                toolTip={'view offer'}
                                                                                icon={
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 20 21" fill="none">
                                                                                        <path d="M7.50004 10.0833L9.16671 11.75L12.9167 8M16.6667 10.5C16.6667 14.5904 12.2051 17.5653 10.5817 18.5124C10.3972 18.62 10.305 18.6738 10.1748 18.7018C10.0737 18.7234 9.92634 18.7234 9.82531 18.7018C9.69512 18.6738 9.60287 18.62 9.41838 18.5124C7.79501 17.5653 3.33337 14.5904 3.33337 10.5V6.51467C3.33337 5.84841 3.33337 5.51528 3.44234 5.22892C3.5386 4.97595 3.69503 4.75023 3.89809 4.57128C4.12795 4.3687 4.43987 4.25173 5.06371 4.01779L9.53188 2.34223C9.70512 2.27726 9.79175 2.24478 9.88086 2.2319C9.9599 2.22048 10.0402 2.22048 10.1192 2.2319C10.2083 2.24478 10.295 2.27726 10.4682 2.34223L14.9364 4.01779C15.5602 4.25173 15.8721 4.3687 16.102 4.57128C16.3051 4.75023 16.4615 4.97595 16.5577 5.22892C16.6667 5.51528 16.6667 5.84841 16.6667 6.51467V10.5Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                }
                                                                                handleClick={() => viewOffer(offer)}

                                                                            />
                                                                        </div>
                                                                    </>

                                                                </Row>
                                                            </Col>

                                                            <Col sm={1}>
                                                                <Row className={styles.tableOptionRow}>
                                                                    <div className={styles.tableOptionIconDiv}>
                                                                        <Dropdown
                                                                            alignRight={true}
                                                                        >
                                                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu className={styles.dropdownMenu}>
                                                                                <Dropdown.Item onClick={() => viewCandidate(offer.candidate_id)} className={styles.dropdownText}>View Candidate</Dropdown.Item>
                                                                                <Dropdown.Item onClick={() => viewOffer(offer)} className={styles.dropdownText}>View Offer</Dropdown.Item>

                                                                                {/* edit offer */}
                                                                                <span data-tip data-for={(offer.state == 20) ? `EditOfferBlockedDueToOfferSent` : null}>
                                                                                    <Dropdown.Item className={((offer.state != 0 && offer.state != 10 && offer.state != -10 && offer.state != -20)) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => editOffer(offer)} disabled={((offer.state != 0 && offer.state != 10 && offer.state != 30 && offer.state != -10 && offer.state != -20 && offer.state != -21)) ? true : false}>Edit Offer</Dropdown.Item>
                                                                                </span>

                                                                                {/* Mark As Offer Sent */}
                                                                                <span data-tip data-for={(offer.state == 0) ? `SendOfferBlockedDueToPendingApproval` : (offer.state == 20) ? `SendOfferBlockedDueToOfferSent` : (offer.state == -10) ? `SendOfferBlockedDueToApprovalRejected` : (offer.state == -20) ? `OfferActionBlockedDueToCandidateAlreadyDeclined` : null}>
                                                                                    <Dropdown.Item className={(offer.state != 10) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickMarkAsOfferSent(offer)} disabled={(offer.state != 10) ? true : false}>Mark As Offer Sent</Dropdown.Item>
                                                                                </span>

                                                                                {/* Send Offer */}
                                                                                <span data-tip data-for={(offer.state == 0) ? `SendOfferBlockedDueToPendingApproval` : (offer.state == 20) ? `SendOfferBlockedDueToOfferSent` : (offer.state == -10) ? `SendOfferBlockedDueToApprovalRejected` : (offer.state == -20) ? `OfferActionBlockedDueToCandidateAlreadyDeclined` : null}>
                                                                                    <Dropdown.Item className={(offer.state != 10) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickSendOffer(offer)} disabled={(offer.state != 10) ? true : false}>Send Offer</Dropdown.Item>
                                                                                </span>

                                                                                {/* Mark As Offer Declined*/}
                                                                                <span data-tip data-for={(offer.state == 0 || offer.state == 10 || offer.state == -10) ? `OfferActionBlockedDueToOfferNotSent` : (offer.state == -20) ? `OfferActionBlockedDueToCandidateAlreadyDeclined` : null}>
                                                                                    <Dropdown.Item className={(offer.state != 20) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickCandidateDeclined(offer)} disabled={(offer.state != 20) ? true : false}>Mark As Offer Declined</Dropdown.Item>
                                                                                </span>

                                                                                {/* Mark as ofeer retracted*/}
                                                                                <span data-tip data-for={(offer.state == 20) ? `OfferRetractionBlockedDueToOfferInOfferSentMode` : null}>
                                                                                    <Dropdown.Item className={(offer.state != 0 && offer.state != 10 && offer.state != -10 && offer.state != -20) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickOfferRetracted(offer)} disabled={(offer.state != 0 && offer.state != 10 && offer.state != -10 && offer.state != -20) ? true : false}>Mark As Offer Retracted</Dropdown.Item>
                                                                                </span>
                                                                                <Dropdown.Divider />

                                                                                {/* Offer Accepted*/}
                                                                                <span data-tip data-for={(offer.state == 0 || offer.state == 10 || offer.state == -10) ? `OfferActionBlockedDueToOfferNotSent` : (offer.state == -20) ? `OfferActionBlockedDueToCandidateAlreadyDeclined` : null}>
                                                                                    <Dropdown.Item className={(offer.state != 20) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickCandidateAcceptedOffer(offer)} disabled={(offer.state != 20) ? true : false}>Offer Accepted (Hired)</Dropdown.Item>
                                                                                </span>

                                                                                <ReactTooltip id={`EditOfferBlockedDueToOfferSent`} place="left" type="dark" effect="solid" clickable={true}>
                                                                                    <div className={styles.toolTipBox}>{<p>Cannot edit. Because the offer is already sent to the candidate</p>}</div>
                                                                                </ReactTooltip>
                                                                                <ReactTooltip id={`SendOfferBlockedDueToPendingApproval`} place="left" type="dark" effect="solid" clickable={true}>
                                                                                    <div className={styles.toolTipBox}>{<p>Blocked due to pending approval</p>}</div>
                                                                                </ReactTooltip>
                                                                                <ReactTooltip id={`OfferRetractionBlockedDueToOfferInOfferSentMode`} place="left" type="dark" effect="solid" >
                                                                                    <div className={styles.toolTipBoxNew}>{<p>Blocked. Because before retracting, first mark as offer declined</p>}</div>
                                                                                </ReactTooltip>
                                                                                <ReactTooltip id={`SendOfferBlockedDueToOfferSent`} place="left" type="dark" effect="solid" >
                                                                                    <div className={styles.toolTipBoxNew}>{<p>Blocked. Because the offer is already sent to the candidate</p>}</div>
                                                                                </ReactTooltip>
                                                                                <ReactTooltip id={`SendOfferBlockedDueToApprovalRejected`} place="left" type="dark" effect="solid" >
                                                                                    <div className={styles.toolTipBoxNew}>{<p>Blocked due to offer approval rejected</p>}</div>
                                                                                </ReactTooltip>
                                                                                <ReactTooltip id={`OfferActionBlockedDueToOfferNotSent`} place="left" type="dark" effect="solid" >
                                                                                    <div className={styles.toolTipBoxNew}>{<p>Blocked. Because you have to send the offer first</p>}</div>
                                                                                </ReactTooltip>
                                                                                <ReactTooltip id={`OfferActionBlockedDueToCandidateAlreadyDeclined`} place="left" type="dark" effect="solid" >
                                                                                    <div className={styles.toolTipBoxNew}>{<p>Blocked.The candidate has already declined the offer</p>}</div>
                                                                                </ReactTooltip>
                                                                                <ReactTooltip id={`PermissionDeniedInfo`} place="left" type="dark" effect="solid" >
                                                                                    <div className={styles.toolTipBoxNew}>{<p>Permission denied.</p>}</div>
                                                                                </ReactTooltip>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </Row>
                                                            </Col>
                                                        </div>
                                                    );

                                                })
                                                }

                                            </div>
                                            <div>
                                                {filteredValues.length > 9 &&

                                                    <div className={styles.bottomTableDiv}>
                                                        <div className={styles.bottomTableControlsWrapper}>
                                                            <div className={styles.bottomTableControlsNextBtn}>
                                                                <CustomButton
                                                                    id="offer_view_go_to_previous_page_btn"
                                                                    label="Previous"
                                                                    handleClick={handlePreviousClick}
                                                                    disabled={currentPage === 1}
                                                                    type="defaultSmallBtn"
                                                                />
                                                            </div>
                                                            <div>
                                                                <CustomButton
                                                                    id="offer_view_go_to_next_page_btn"
                                                                    label="Next"
                                                                    type="defaultSmallBtn"
                                                                    handleClick={handleNextClick}
                                                                    disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <span className={styles.paginationInfo}>
                                                                Page {currentPage} of {totalPages}
                                                            </span>
                                                        </div>

                                                    </div>
                                                }
                                            </div>
                                        </>)
                            }
                        </div>

                    </div>
                </div>
            }
        </div>
    )
}

export default OfferHandling;